export const APPLICATION_STATUS = {
    SUBMITTED: 'SUBMITTED',
    APPROVED: 'APPROVED', 
    CONTRACT_CONCLUSION: 'CONTRACT_CONCLUSION',
    COMPLETED: 'COMPLETED',
    REJECTED: 'REJECTED'
};

export const APPLICATION_STATUS_DISPLAY = {
    SUBMITTED: 'Подана',
    APPROVED: 'Одобрена',
    CONTRACT_CONCLUSION: 'Заключение договора', 
    COMPLETED: 'Завершена',
    REJECTED: 'Отклонена'
};